(function () {
    'use strict';
    EO_PlGeneralActionsController.$inject = ['$scope', '$attrs', '$element', '$mdBottomSheet'];

    function EO_PlGeneralActionsController($scope, $attrs, $element, $mdBottomSheet) {
//
        var $ctrl = this;
        $ctrl.openActions = function () {
            $mdBottomSheet.show({
                templateUrl: 'app/components/eyeson/pl-general-actions/general-actions-bottom-sheet-template.html',
                controller: 'GeneralActionsBottomSheetController',
                controllerAs: 'vm',
                clickOutsideToClose: true
                // resolve: {
                //     // entity: (function () {
                //     //     return {
                //     //
                //     //     };
                //     // })
                //
                //
                // },
            }).then(function (result) {
                switch (result) {
                }
            }).catch(function (error) {
                // User clicked outside or hit escape
            });
        }

    }


    var EO_PlGeneralActions = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/pl-general-actions/eyeson.pl-general-actions.template.html',
        controller: EO_PlGeneralActionsController,
        bindings: {}


    };

    angular
        .module('tikonApp')
        .component('eoPlGeneralActions', EO_PlGeneralActions)


})();

